import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
  query,
  where,
  getDoc
} from "firebase/firestore";
import { db } from "../firebase/config";
import "./ChildShop.css";
import Emoji from "../components/Emoji";
import ChildBottomNav from "../components/ChildBottomNav";

function ChildShop() {
  const [items, setItems] = useState([]);
  const [child, setChild] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("selectedUser"));
    if (!user || user.type !== "child") {
      window.location.href = "/";
    } else {
      loadChildById(user.id);
      loadItems();
      calculateWaitingPointsById(user.id);
    }
  }, []);

  const loadChildById = async (id) => {
    const ref = doc(db, "users", id);
    const snapshot = await getDoc(ref);
    if (snapshot.exists()) {
      setChild({ id: snapshot.id, ...snapshot.data() });
    }
  };

  const calculateWaitingPointsById = async (childId) => {
    const q = query(
      collection(db, "taskHistory"),
      where("child", "==", childId),
      where("status", "==", "done")
    );
    const snapshot = await getDocs(q);
    const total = snapshot.docs.reduce((sum, doc) => sum + Number(doc.data().points || 0), 0);
    setChild(prev => ({ ...prev, waitingPoints: total }));
  };

  const loadItems = async () => {
    const snap = await getDocs(collection(db, "shopItems"));
    setItems(
      snap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(item => item.active !== false)
    );
  };

  const purchaseItem = async (item) => {
    if (!child) return;

    if (child.points < item.price) {
      setMessage("Недостатньо балів для покупки");
      return;
    }

    const childRef = doc(db, "users", child.id);
    await updateDoc(childRef, {
      points: child.points - item.price
    });

    await addDoc(collection(db, "purchaseHistory"), {
      child: child.id, // зберігаємо ID дитини
      title: item.title,
      itemId: item.id,
      image: item.image,
      price: Number(item.price),
      purchasedAt: new Date()
    });

    await loadChildById(child.id);
    await calculateWaitingPointsById(child.id);
    setMessage(`Ти придбав "${item.title}"!`);
  };

  return (
    <div className="child-shop">
      <div className="child-shop-shell">
        <header className="child-shop-header">
          <div className="child-shop-header-inner">
            <div className="child-shop-profile-row">
              <img src={child?.photo} alt={child?.name || ""} className="avatar-large" />
              <h2>{child?.name}</h2>
            </div>
            <div className="shop-points-block">
              <div className="shop-points"><Emoji label="Кубок" symbol="🏆" /> {Number(child?.points || 0)} балів</div>
              <div className="shop-waiting"><Emoji label="Годинник" symbol="🕐" /> В очікуванні: {Number(child?.waitingPoints || 0)} балів</div>
            </div>
          </div>
        </header>

        {message && <div className="shop-message">{message}</div>}

        <main className="shop-content">
          <h3>Магазин</h3>
          <div className="shop-list">
            {items.map(item => (
              <div key={item.id} className="shop-card">
                <img src={item.image} alt={item.title} className="shop-image" />
                <div className="shop-card-main">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
                <div className="shop-card-footer">
                  <p className="shop-price"><Emoji label="Кубок" symbol="🏆" /> {item.price} балів</p>
                  <button type="button" onClick={() => {
                    setSelectedItem(item);
                    setShowConfirm(true);
                  }}>
                    Придбати
                  </button>
                </div>
              </div>
            ))}
          </div>
        </main>

        <ChildBottomNav />

        {showConfirm && selectedItem && (
          <div className="shop-modal-backdrop">
            <div className="shop-modal-content">
              <h3>Підтвердження покупки</h3>
              <p>
                Ти хочеш придбати <strong>{selectedItem.title}</strong> за <strong>{selectedItem.price} балів</strong>?
              </p>
              <button
                type="button"
                onClick={() => {
                  purchaseItem(selectedItem);
                  setShowConfirm(false);
                  setSelectedItem(null);
                }}
              >
                Так, придбати
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowConfirm(false);
                  setSelectedItem(null);
                }}
              >
                Скасувати
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChildShop;
